<!--  TODO: add Fax and Conference (waiting for endpoint) -->
<script>
import NavigationHeader from '../NavigationHeader.vue';
import ButtonIconLeft from '../buttons/ButtonIconLeft.vue';
import GroupService from '@/services/GroupService';
import UserService from '@/services/UserService';
import PhonenumberService from '@/services/PhonenumberService';
import SorterService from '@/services/SorterService';
import axios from 'axios';

export default {
    name: 'PhoneNumbersOverview',
    components: {
        NavigationHeader,
        ButtonIconLeft,
    },
    data() {
        return {
            phoneNumberList: [],
            phonenumbersCountInTotal: 0,
            phonenumbersAssignedCount: 0
        };
    },
    created() {
        const self = this;
        axios.all([
            PhonenumberService.getAllPhonenumbers(),
            UserService.getAllUsers(),
            GroupService.getAllGroups(),
            ]).then(
            axios.spread((phoneNumbers, users, groups) => {
                if (phoneNumbers.status === 200 && users.status === 200 && groups.status === 200) {
                    self.getPhonenumberCounters(phoneNumbers.data);
                    self.modifyPhoneNumbers(phoneNumbers.data);
                    self.userList = users.data;
                    self.groupList = groups.data;
                    self.addAssignmentToNumber();
                } else {
                    self.phoneNumberList = '';
                }
            }));
    },
    methods: {
        modifyPhoneNumbers(phoneNumbers) {
            for (const entry of phoneNumbers) {
                if (PhonenumberService.entryPassesClientDefinedFilter(entry)) {
                    this.phoneNumberList.push(entry);
                }
            }
            SorterService._sortArrayOfStringsByParam(this.phoneNumberList, 'number');
        },
        getPhonenumberCounters(list) {
            const result = PhonenumberService.getCountOfAllPhonenumbers(list);
            this.phonenumbersCountInTotal = result.countOfAllPhonenumbers;
            this.phonenumbersAssignedCount = result.countOfAllAssignedPhonenumbers;
        },
        addAssignmentToNumber() {
            for (const phoneNumber of this.phoneNumberList) {
                if (phoneNumber.assignedGroupAccountId) {
                    for (const group of this.groupList) {
                        if (group.id === phoneNumber.assignedGroupAccountId) {
                            phoneNumber.assignmentName = group.groupname;
                        }
                    }
                } else if (phoneNumber.assignedModuleInstanceId) {
                    phoneNumber.assignmentName = 'HOTLINE';
                } else if (phoneNumber.assignedUserAccountId) {
                    for (const user of this.userList) {
                        if (user.id === phoneNumber.assignedUserAccountId) {
                            if (user.familyName !== 'FaxUser') {
                                phoneNumber.assignmentName = user.familyName + ', ' + user.firstName;
                            } else {
                                phoneNumber.assignmentName = 'Fax';
                            }
                        }
                    }
                } else if (phoneNumber.assignedServiceId === 11) {
                    phoneNumber.assignmentName = 'Telefonkonferenznummer';
                }
            }
        },
    },
};
</script>
    
<template>
<div class="container">
    <div id="phone-number-overview">
        <NavigationHeader route="/" navigationText="zurück zum Dashboard" title="Rufnummernübersicht" />

        <div class="wrapper">
                
            <table class="table">
                <tr>
                    <th class="header">Rufnummer</th>
                    <th class="header">Benutzer</th>
                    <th class="header"></th>
                </tr>
                <tr v-for="entry in phoneNumberList" :key="entry.id">
                    <td class="phone-number">{{entry.exitCode === '00' ? '+': entry.exitCode}}{{entry.nationalPrefix}} {{entry.localPrefix}} {{entry.number}}</td>
                    <td class="assignment">
                        <img v-if="entry.assignedGroupAccountId" src="@/assets/starface_icons_png/24/orange/teams_24.png" alt="Logo Group">
                        <img v-if="entry.assignedModuleInstanceId" src="@/assets/starface_icons_png/24/orange/teams_24.png" alt="Logo Group">
                        <img v-if="entry.assignedUserAccountId && entry.assignedServiceId === 17" src="@/assets/starface_icons_png/24/orange/fax_24.png" alt="Logo User">
                        <img v-else-if="entry.assignedUserAccountId" src="@/assets/starface_icons_png/24/orange/outline_24.png" alt="Logo User">
                        <img v-if="entry.assignedServiceId === 11" class="conference-icon" src="@/assets/starface_icons_png/24/orange/conference_24.png" alt="Logo User">
                        <span v-if="entry.assignmentName">{{entry.assignmentName}}</span>
                        <span v-if="!entry.assignmentName" class="without">frei</span>
                    </td>
                    <td></td>
                </tr>
            </table>
            <div class="utilized-users">
                <span>Verwendete Rufnummern: {{phonenumbersAssignedCount}}/{{phonenumbersCountInTotal}}</span>
            </div>
        </div>
    </div>
</div>
</template>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
#phone-number-overview {
    .wrapper {
        display: grid;
        display: -ms-grid;
        grid-template-columns: 1fr;
        -ms-grid-columns: 1fr;
        max-width: 1024px;
        margin: auto;
        .table {
            grid-row: 1;
            -ms-grid-row: 1;
            justify-self: start;
            text-align: left;
            border-spacing: 0;
            padding: 16px 0;
            width: 100%;
            max-width: 1024px;
            font-size: 18px;
            .header {
                color: white;
                font-weight: bold;
                background-color: $th-background-color;
                padding: 6px 16px;
                text-align: left;
            }
            tr {
                height: 48px;
            }
            tr:nth-child(odd) {
                background-color: white;
            }
            td {
                padding: 6px 16px;
                .phone-number {
                    font-weight: bold;
                }
                .assignment {
                    display: flex;
                    align-items: center;
                    .without {
                        color: $grey-light ;
                    }

                }
                img {
                    padding-right: 8px;
                }
            }
            .btn-edit {
                float: right;
            }
            .family-name {
                font-weight: bold;
            }
        }
        .utilized-users {
            grid-row: 2;
            -ms-grid-row: 2;
            justify-self: end;
            -ms-grid-column-align: end;
            color: $grey-dark;
            font-size: 18px;
            padding-bottom: 32px;
            padding-top: 16px;
            padding-right: 24px;
        }
    }
}
</style>
